import { IntegrationStatus } from 'modules/integrations/domain/enums';
import { TelegramIntegration, TournamentIntegrationDto } from 'modules/integrations/domain/interfaces';

const TELEGRAM_TYPENAME = 'TelegramTournamentIntegration';

export function mapTelegramIntegration(dto: TournamentIntegrationDto): TelegramIntegration | null {
  if (dto.__typename !== TELEGRAM_TYPENAME || dto.id === undefined) return null;

  return {
    id: dto.id,
    // Неизвестный статус считаем отключением: публиковать в такой канал безопаснее не давать.
    status: dto.status === IntegrationStatus.ACTIVE ? IntegrationStatus.ACTIVE : IntegrationStatus.DISCONNECTED,
    chatId: dto.chatId ?? '',
    channelUsername: dto.channelUsername ?? null,
    channelUrl: dto.channelUrl ?? null,
    lastPublishedAt: dto.lastPublishedAt ?? null,
  };
}

/** Telegram-интеграция организации из общего списка; другие типы (появятся позже) пропускаются. */
export function pickTelegramIntegration(dtos: TournamentIntegrationDto[]): TelegramIntegration | null {
  for (const dto of dtos) {
    const integration = mapTelegramIntegration(dto);
    if (integration) return integration;
  }

  return null;
}
